import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFaqDetailList } from "../../store/Slice/faqDetailSlice";
import { useLocation, useNavigate } from "react-router-dom";

const FreQuestion = ({ labelDetailData }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { state } = useLocation();
  const { serviceId } = state || {};

  const pathname = location.pathname;

  const saved = sessionStorage.getItem("faqUserType");
  const viewButtonClick = sessionStorage.getItem("viewAllButtonClick");

  const checkPath =
    location && location.pathname && location.pathname.split("/")[1];

  const [userType, setUserType] = React.useState(saved);

  React.useEffect(() => {
    if (viewButtonClick) {
      dispatch(getFaqDetailList({ eType: userType }));
    } else if (serviceId) {
      dispatch(
        getFaqDetailList({
          iServiceId: serviceId,
        })
      );
    } else {
      dispatch(
        getFaqDetailList({
          eType: checkPath === "join-us" ? "Contractor" : "Customer",
        })
      );
    }
  }, [dispatch, viewButtonClick, checkPath, serviceId ,userType]);

  const { faqDetailData, loading } = useSelector(
    (state) => state.faqDetailList
  );
  const faqData = faqDetailData?.code === 200 ? faqDetailData.data : [];

  const handleFaqViewAll = () => {
    sessionStorage.setItem("viewAllButtonClick", "true");

    const type = pathname === "/join-us" ? "Contractor" : "Customer";
    setUserType(type);
    sessionStorage.setItem("faqUserType", type);
    navigate("/frequently-asked-questions");
  };

  const labelKeys = [
    "LBL_HOME_FREQUENTLY_ASKED_QUESTION_HEADING",
    "LBL_ABOUT_US_FREQUENTLY_ASKED_QUESTION_HEADING",
    "LBL_BOOK_NOW_FREQUENTLY_ASKED_HEADING",
    "LBL_JOIN_US_FREQUENTLY_ASKED_QUESTION_HEADING",
    "LBL_CONTACT_US_FREQUENTLY_ASKED_QUESTION_HEADING",
  ];
  const faqTitle =
    labelDetailData?.code === 200 &&
    labelKeys
      .map(
        (key) => labelDetailData.data.find((item) => item.vLabel === key)?.tText
      )
      .find((t) => !!t);

  return (
    <section className="frequestion-section pb-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 text-center">
            <h2 className="main-title">
              {faqTitle || "Frequently Asked Questions"}
            </h2>
          </div>
        </div>

        {loading ? null : faqData.length > 0 ? (
          <div className="frequently-questioncard">
            <div className="accordion" id="accordionExample">
              {(pathname === "/frequently-asked-questions"
                ? faqData
                : faqData.slice(0, 5)
              ).map((faq, idx) => (
                <div className="accordion-item" key={idx}>
                  <h3 className="accordion-header">
                    <button
                      className={`accordion-button ${
                        idx === 0 ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${idx}`}
                      aria-expanded={idx === 0}
                      aria-controls={`collapse${idx}`}
                    >
                      {faq.vQuestion}
                    </button>
                  </h3>
                  <div
                    id={`collapse${idx}`}
                    className={`accordion-collapse collapse ${
                      idx === 0 ? "show" : ""
                    }`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">{faq.vAnswer}</div>
                  </div>
                </div>
              ))}
            </div>

            {faqData.length > 5 &&
              pathname !== "/frequently-asked-questions" && (
                <div className="section-headbtnDiv text-center mt-2">
                  <button
                    className="success-orangebtn"
                    onClick={handleFaqViewAll}
                  >
                    View All
                  </button>
                </div>
              )}
          </div>
        ) : (
          <div className="col-12">
            <p
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px 0",
              }}
            >
              No Data Found
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default FreQuestion;
